import { UseProgressDataReturn, useProgressData } from "@hooks/game/progress/use-progress-data";
import { createContext, useContext, type PropsWithChildren } from "react";

interface ProgressContextType extends UseProgressDataReturn {}

const ProgressContext = createContext<ProgressContextType | null>(null);

export const ProgressProvider = ({ children }: PropsWithChildren) => {
  const progressData = useProgressData();

  return <ProgressContext.Provider value={progressData}>{children}</ProgressContext.Provider>;
};

export const useProgress = () => {
  const context = useContext(ProgressContext);
  if (!context) {
    throw new Error("useProgress must be used within a ProgressProvider");
  }
  return context;
};
